var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              !_vm.showSpecificRecordDetails
                ? _c(
                    "div",
                    { staticClass: "header-extra" },
                    [
                      _c("ColumnToggle", {
                        attrs: {
                          "table-name": "publisherMaps",
                          "user-settings": _vm.userSettings,
                          "settings-status": _vm.getUserSettingsStatus,
                          "column-settings": _vm.columnSettings
                        },
                        on: { onChange: _vm.updateUserVisibleColumns }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm widget-header-button m-r-5",
                          on: {
                            click: function($event) {
                              return _vm.exportToCSV()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("EXPORT_CSV")) +
                              "\n      "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.name.value,
                            expression: "filters.name.value"
                          }
                        ],
                        staticClass:
                          "form-control input-md widget-header-input m-r-10",
                        attrs: {
                          type: "search",
                          "data-testid": "publishers-search",
                          placeholder: _vm.$t("PUBLISHERS_SEARCH_PH")
                        },
                        domProps: { value: _vm.filters.name.value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filters.name,
                              "value",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.isFetchingPublishers
        ? _c("div", { staticClass: "m-b-15 m-t-10" }, [
            _vm.hasCreateAccess && !_vm.showSpecificRecordDetails
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-success btn-sm",
                    attrs: {
                      type: "button",
                      "data-testid": "publishers-create-button",
                      disabled: _vm.formActive && !_vm.activePublisher
                    },
                    on: {
                      click: function($event) {
                        return _vm.showForm(null, $event)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "PUBLISHERS_ADD_BUTTON",
                          expression: "'PUBLISHERS_ADD_BUTTON'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showSpecificRecordDetails
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    on: { click: _vm.goToPublishers }
                  },
                  [
                    _c("i", { staticClass: "fa fa-arrow-left" }),
                    _vm._v(" "),
                    _c("span", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "PUBLISHER_SHOW_ALL",
                          expression: "'PUBLISHER_SHOW_ALL'"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFetchingPublishers
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.publishers,
                    "current-page": _vm.currentPage,
                    "page-size": 20,
                    filters: _vm.filters,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              !_vm.showAddNewForm && _vm.publishers.length == 0
                                ? _c("tr", [
                                    _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "PUBLISHERS_HEADER_NONE",
                                          expression: "'PUBLISHERS_HEADER_NONE'"
                                        }
                                      ],
                                      attrs: { colspan: "100" }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAddNewForm && _vm.hasCreateAccess
                                ? _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "row-inline-new-form slide-down bg-row-even"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { attrs: { colspan: "100" } },
                                        [
                                          !_vm.showNewPublisherInvites
                                            ? _c("PublisherForm", {
                                                attrs: {
                                                  "is-inline-table": "true",
                                                  "show-loader":
                                                    _vm.isCreatePublisherLoading,
                                                  "account-settings":
                                                    _vm.accountSettings
                                                },
                                                on: {
                                                  cancel: _vm.hideForm,
                                                  submit:
                                                    _vm.handleAddPublisherSubmit
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showNewPublisherInvites &&
                                          _vm.invitesForPublisher
                                            ? _c("PublisherInvites", {
                                                attrs: {
                                                  "publisher-id":
                                                    _vm.invitesForPublisher.id,
                                                  "close-btn-text": _vm.isNewUserToNewPublisherInvited
                                                    ? "Close"
                                                    : "Skip"
                                                },
                                                on: {
                                                  close:
                                                    _vm.onNewPublisherInvitesClose,
                                                  "created-new-invite":
                                                    _vm.onAddingNewInviteToNewPublisher
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "title",
                                                      fn: function() {
                                                        return [
                                                          _c("p", [
                                                            _vm._v(
                                                              "\n                  Invite Users to\n                  "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .invitesForPublisher
                                                                    .name
                                                                )
                                                              )
                                                            ])
                                                          ])
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(publisher, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == publisher.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: publisher.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    attrs: {
                                                      disabled:
                                                        _vm.showAddNewForm
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          publisher.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "name"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings["name"]
                                                        .rowAlign
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "clickable",
                                                      attrs: {
                                                        href: _vm.getPublisherEditHref(
                                                          publisher.id
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showForm(
                                                            publisher,
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(
                                                            publisher.name
                                                          ) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes("id")
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings["id"]
                                                        .rowAlign
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "clickable",
                                                      attrs: {
                                                        href: _vm.getPublisherEditHref(
                                                          publisher.id
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showForm(
                                                            publisher,
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(publisher.id) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "createNumbers"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName:
                                                        "v-tooltip.right.hover",
                                                      value: _vm.$t(
                                                        "PUBLISHERS_CREATE_NUMBERS_TT"
                                                      ),
                                                      expression:
                                                        "$t('PUBLISHERS_CREATE_NUMBERS_TT')",
                                                      modifiers: {
                                                        right: true,
                                                        hover: true
                                                      }
                                                    }
                                                  ],
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "createNumbers"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        publisher.createNumbers
                                                          ? "Yes"
                                                          : "No"
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentLive"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentLive"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        publisher.currentLive
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentHour"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentHour"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        publisher.currentHour
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentDay"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentDay"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        publisher.currentDay
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "currentMonth"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "currentMonth"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(
                                                        publisher.currentMonth
                                                      ) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "total"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "total"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(publisher.total) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.userVisibleColumns.includes(
                                            "enabled"
                                          )
                                            ? _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align:
                                                      _vm.columnSettings[
                                                        "enabled"
                                                      ].rowAlign
                                                  }
                                                },
                                                [
                                                  _c("Status", {
                                                    attrs: { entity: publisher }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("PublisherActions", {
                                                    attrs: {
                                                      "create-access":
                                                        _vm.hasCreateAccess,
                                                      "current-publisher": publisher,
                                                      disabled:
                                                        _vm.formActive ||
                                                        _vm.disabled,
                                                      "is-admin": _vm.isAdmin,
                                                      href: _vm.getPublisherEditHref(
                                                        publisher.id
                                                      )
                                                    },
                                                    on: {
                                                      "collapse-actions": function(
                                                        $event
                                                      ) {
                                                        !_vm.disabled &&
                                                          _vm.hideMobileAction()
                                                      },
                                                      "show-edit-form":
                                                        _vm.showForm,
                                                      "confirm-delete":
                                                        _vm.openConfirmDeletePublisherModal,
                                                      "show-invites":
                                                        _vm.showInvites,
                                                      "confirm-pause":
                                                        _vm.openConfirmPausePublisherModal,
                                                      "set-status":
                                                        _vm.setPublisherStatus,
                                                      "show-publisher-references":
                                                        _vm.showPublisherReferences
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeReferencesRowId === publisher.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: publisher.id + "-references",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "p-l-15 p-r-15"
                                                },
                                                [
                                                  _c(
                                                    "legend",
                                                    {
                                                      staticClass:
                                                        "f-s-13 p-b-10 p-l-0"
                                                    },
                                                    [
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value: "REFERENCES",
                                                            expression:
                                                              "'REFERENCES'"
                                                          }
                                                        ]
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-xs btn-danger legend-right-button",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.hidePublisherReferences
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-close",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "\n                    Close\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("PublisherReferences", {
                                                    attrs: {
                                                      "pub-id": publisher.id
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  publisher.showInvites
                                    ? _c(
                                        "tr",
                                        {
                                          key: publisher.id + "-invites",
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("PublisherInvites", {
                                                attrs: {
                                                  "publisher-id": publisher.id
                                                },
                                                on: {
                                                  close: function($event) {
                                                    return _vm.hideInvites(
                                                      publisher
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  publisher.showEditForm
                                    ? _c(
                                        "tr",
                                        {
                                          key: publisher.id + "-edit",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c("PublisherForm", {
                                                attrs: {
                                                  "show-loader":
                                                    _vm.isUpdatePublisherLoading,
                                                  publisher: publisher,
                                                  "account-settings":
                                                    _vm.accountSettings
                                                },
                                                on: {
                                                  cancel: _vm.hideForm,
                                                  submit:
                                                    _vm.handleUpdatePublisherSubmit
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == publisher.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: publisher.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("PublisherActions", {
                                                attrs: {
                                                  "create-access":
                                                    _vm.hasCreateAccess,
                                                  "current-publisher": publisher,
                                                  disabled:
                                                    _vm.formActive ||
                                                    _vm.disabled,
                                                  "is-admin": _vm.isAdmin
                                                },
                                                on: {
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  "show-edit-form":
                                                    _vm.showForm,
                                                  "confirm-delete":
                                                    _vm.openConfirmDeletePublisherModal,
                                                  "show-invites":
                                                    _vm.showInvites,
                                                  "confirm-pause":
                                                    _vm.openConfirmPausePublisherModal,
                                                  "set-status":
                                                    _vm.setPublisherStatus,
                                                  "show-publisher-references":
                                                    _vm.showPublisherReferences
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    3063428748
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.userVisibleColumns, function(col) {
                          return _c("v-th", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.columnSettings[col].displayName,
                                expression: "columnSettings[col].displayName"
                              }
                            ],
                            key: col,
                            class: _vm.columnSettings[col].class,
                            attrs: {
                              "default-sort":
                                _vm.columnSettings[col].defaultSort,
                              "sort-key": _vm.columnSettings[col].name
                            }
                          })
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "ACTIONS_COLUMN_HEADER",
                                  expression: "'ACTIONS_COLUMN_HEADER'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 20
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFetchingPublishers
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "PUBLISHERS_HEADER_LOADING",
                    expression: "'PUBLISHERS_HEADER_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteModal
        ? _c("PublisherDeleteModal", {
            attrs: {
              publisher: _vm.publisherForDelete,
              "loading-deleting-publisher": _vm.isPublisherDeleteLoading,
              "loading-publisher-references": _vm.isPublisherReferencesLoading,
              "publisher-references": _vm.publisherReferences,
              "check-references-text": _vm.checkReferencesText
            },
            on: { confirm: _vm.confirmDelete, close: _vm.closeDeleteModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPauseModal
        ? _c("PublisherPauseModal", {
            attrs: { publisher: _vm.publisherForPause },
            on: { confirm: _vm.setPublisherStatus, close: _vm.closePauseModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }